<template>
  <div class="blue-btn" v-tap="{methods:handleClick}">
    {{info}}
  </div>
</template>

<script>
  export default{
    name: 'blue-btn',
    data () {
      return {};
    },
    props: {
      info: String,
      handleClick: Function
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import "../assets/scss/base.scss";

  .blue-btn {
    font-family: 'SXSLST';
    font-size: px2rem(34);
    width: px2rem(164);
    height: px2rem(74);
    line-height: px2rem(72);
    margin: 0 auto;
    color: white;
    @include bg-img('../assets/img/common/blue_btn_bg');
    @include text-shadow(2, 2, rgba(25, 55, 139, 0.75))
  }
</style>



// WEBPACK FOOTER //
// BlueBtn.vue?71439697